var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { createContext } from 'react';
import { LoadingPage } from './LoadingPage';
import { initialAuthState } from './reducer';
var notImplemented = function () {
    throw new Error('Looks like you forgot to add the AuthProvider to your App!');
};
var defaultContext = __assign(__assign({}, initialAuthState), { loadingComponent: LoadingPage, logout: notImplemented, getClaims: notImplemented, getAccessToken: notImplemented, loginWithRedirect: notImplemented, loginWithPopup: notImplemented, getDomainScopes: notImplemented, loginWithDomainScope: notImplemented });
export var AuthContext = createContext(defaultContext);
//# sourceMappingURL=AuthContext.js.map